module.exports = __webpack_public_path__ + "img/me.18631c31.jpg";